module.exports = __webpack_public_path__ + "static/mehmetcik_vakfi-66fa86d9255b03ee5c0ae8a5f45d8256.png";